<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar color="primary" dark>利用者再登録</v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-card :disabled="!ryoseiFlg" max-width="800px">
                <v-row>
                  <v-col cols="12" sm="5" md="5" lg="5">
                    <ryou-select
                      v-model="selectBuild"
                      :value="selectBuild"
                      :label="'物件名選択'"
                      :items="buildItems"
                      :itemText="'code_text'"
                      :itemValue="'code_value'"
                      :rules="buildRules"
                    >
                    </ryou-select>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="3">
                    <ryou-input
                      v-model="room_id"
                      :value="room_id"
                      :label="'部屋番号'"
                      :prependIcon="'mdi-office-building-outline'"
                      :appendIcon="'mdi-plus-box'"
                      :rules="roomIdRules"
                      :maxlength="10"
                      :click-icon-function="clickRoomSelect"
                    >
                    </ryou-input>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" lg="4">
                    <ryou-date-format
                      v-model="in_dormitory_date"
                      :value="in_dormitory_date"
                      :type="'date'"
                      :format="'$1/$2/$3'"
                      :label="'入寮日'"
                      :rules="indateRules"
                    >
                    </ryou-date-format>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
            <room-select-dialog
              ref="roomSelect"
              :buildingId="selectBuild"
              :setRoomIdFunc="setRoomIdByChild"
            ></room-select-dialog>
            <UserChangeInformation
              v-show="false"
              ref="userChangeInformation"
            ></UserChangeInformation>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'閉じる'"
            :handlerClick="handleCancel"
            :iconCls="'mdi-close'"
          >
          </ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'登録'"
            :handlerClick="handleOkConfirm"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-dialog>
  </v-row>
</template>

<script>
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import RoomSelectDialog from "@/views/user/modules/RoomSelectDialog.vue";
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
import UserChangeInformation from "@/views/user/UserChangeInformation.vue";

export default {
  components: {
    RyouBlackBtn,
    RyouSelect,
    RyouDateFormat,
    RoomSelectDialog,
    RyouInput,
    RyouConfirm,
    UserChangeInformation,
  },

  props: {
    loadTableDataFunc: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    ryoseiFlg: true,
    dialog: false,
    title: "",
    valid: true,
    selectBuild: "",
    room_id: "",
    buildItems: [],
    in_dormitory_date: "",
    roomIdRules: [],
    indateRules: [],
    buildRules: [],
    record: [],
  }),

  mounted() {
    // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（必須、最大10文字、半角英数記号(-のみ)チェック） start
    this.roomIdRules.push(this.GlobalRules.required);
    this.roomIdRules.push(this.GlobalRules.counter_10);
    this.roomIdRules.push(this.GlobalRules.hanAlphahyphen);
    // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（必須、最大10文字、半角英数記号(-のみ)チェック） end
    //this.buildRules.push(this.GlobalRules.required);
    //this.indateRules.push(this.GlobalRules.required);
  },

  methods: {
    handleCancel() {
      this.close();
    },
    handleOk() {
      let params;
      if (this.ryoseiFlg) {
        params = {
          reRegistration_flg: true,
          loginUserId: this.$store.getters.getUserId,
          user_id: this.record.user_id,
          selectBuild: this.selectBuild,
          room_id: this.room_id,
          in_dormitory_date: this.in_dormitory_date,
          out_dormitory_date: null,
          target_building_id: this.record.building_id.toString(),
          target_room_id: this.record.room_id,
          selectUserClass: this.record.user_class,
        };
      } else {
        params = {
          reRegistration_flg: true,
          loginUserId: this.$store.getters.getUserId,
          user_id: this.record.user_id,
          selectUserClass: this.record.user_class,
        };
      }

      // 再登録利用者情報更新
      this.putRequest(
        "/dormitoryUserRevise/dormitoryUserUpdate",
        params,
        this.$store.getters.getUserToken
      ).then((resp) => {
        if (resp.success) {
          this.$emit("ok");
          this.loadTableDataFunc();
        }
      });

      this.close();
    },
    close() {
      this.selectBuild = "";
      this.room_id = "";
      this.inDormitoryDate = null;
      this.dialog = false;
    },
    open(item) {
      this.dialog = true;
      this.record = item;

      //寮生とそれ以外でコンポーネントの表示を変更
      if (item.user_class == "3") {
        this.ryoseiFlg = true;
        this.selectBuild = item.building_id.toString();
        this.room_id = item.room_id;

        this.roomIdRules.push(this.GlobalRules.hanAlphahyphen); // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（半角英数記号(-のみ)チェック）
        this.roomIdRules.push(this.GlobalRules.required);
        this.buildRules.push(this.GlobalRules.required);
        this.indateRules.push(this.GlobalRules.required);
      } else {
        this.ryoseiFlg = false;
        this.roomIdRules = [];
        this.roomIdRules = [];
        this.buildRules = [];
        this.indateRules = [];
      }

      this.initData();
    },
    initData() {
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/dormitoryUserRevise/buildListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          if (data.result != null) {
            this.buildItems = data.result; //物件名
          } else {
            this.buildItems = [];
            this.buildItems.push("");
          }
        }
      });
    },
    //部屋番号選択
    clickRoomSelect() {
      this.$refs.roomSelect.selectRooms();
    },
    //部屋番号のセッター
    setRoomIdByChild(obj) {
      this.room_id = obj.room_id;
    },
    async handleOkConfirm() {
      var valid = this.$refs.p1DialogForm.validate();
      if (valid) {
        this.$refs.confirm
          .open("登録", "登録します。宜しいですか？", { color: "info" })
          .then(async (confirm) => {
            if (confirm) {
              //寮生の場合のみ部屋重複の警告文取得処理を行う。
              if (this.ryoseiFlg) {
                var flg = false;
                var params = {
                  buildingId: this.selectBuild, //物件ID
                  roomId: this.room_id, //部屋番号
                  inDormitoryDate: this.in_dormitory_date, //入寮日
                  userId: this.record.user_id, //ユーザID
                };
                await this.$refs.userChangeInformation
                  .roomWarningCheck(params)
                  .then(async (msg) => {
                    if (msg != "" && msg != null) {
                      await this.$refs.confirm
                        .open("警告", msg, { color: "warning" })
                        .then((confirm) => {
                          if (!confirm) {
                            flg = true; //キャンセル押下時、それ以降の処理を中断
                          }
                        });
                    }
                  }); //警告文取得
                if (flg) {
                  return;
                }
              }
              this.handleOk();
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.InsertTitle {
  padding: 0px 0px 12px !important;
}
.InsertTitle1 {
  padding: 5px 0px 0px 0px;
}
</style>
